import { Client } from 'src/features/clients/client-data-types';
import { API_BASE_URL } from 'src/features/shared/data/app-settings';
import { PagingObject, QueryOptions, ResponseObject, cursorTypes } from 'src/utils/types';

export async function getClients(
    queryOptions: QueryOptions,
    token: string,
): Promise<ResponseObject<PagingObject<Client>> | null> {
    const clientHead = getClientQueryParameters(queryOptions);

    const CLIENTS_QUERY = `query{
            ${clientHead} {
                totalCount,
                pageInfo {
                    hasNextPage,
                    hasPreviousPage,
                    startCursor,
                    endCursor
                },
                nodes {
                    id,
                    hosts,
                    favouriteLockerEnabled,
                    cui,
                    createdAt
                }
            }
        }
    `;

    const response = await fetch(new URL(`${API_BASE_URL!}\\graphql\\api`), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
        body: JSON.stringify({ query: CLIENTS_QUERY }),
    });

    if (!response.ok) {
        console.error('Error get clients');
        return null;
    }

    const responseData = await response.json();

    const hasError = responseData.data.clients === null && responseData.errors.length > 0;

    return {
        errorStatusCode: hasError ? +responseData.errors[0].extensions.code : null,
        response: responseData.data.clients as unknown as PagingObject<Client>,
    } as ResponseObject<PagingObject<Client>>;
}

const getClientQueryParameters = (queryOptions: QueryOptions): string => {
    let clientHead = `clients(${cursorTypes.first}: ${queryOptions.pageSize}`;
    if (queryOptions.cursor) {
        clientHead += `, after: "${queryOptions.cursor}"`;
    }

    if (queryOptions.searchFilter) {
        clientHead += `, where: {
            or: [{id: {contains: "${queryOptions.searchFilter}"}},
                {hosts: {some: {contains: "${queryOptions.searchFilter}"}}},
                {cui: {contains: "${queryOptions.searchFilter}"}}],
        }`;
    }

    if (queryOptions.sortModel) {
        clientHead += `, order: {
            ${queryOptions.sortModel.field}: ${queryOptions.sortModel.sort.toUpperCase()}
        }`;
    }

    clientHead += ')';

    return clientHead;
};
